/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {CommercePrice} from './CommercePrice';
import {Marker} from './Marker';
import {AvailabilityOnGroupsOfWarehouses, BalancesOnGroupsOfWarehouses} from './ProductCustomer'

export interface CartProduct {
  id: number;
  amount: number;
  articul: string;
  header: string;
  description: string;
  manufacturerHeader: string;
  brandHeader: string;
  unitHeader: string;
  price: number;
  picture: string;
  productId: number | null;
  syncUid: string | null;
  manufacturerId?: number | null;
  brandId?: number | null;
  manufacturerSeriesHeader?: string | null;
  commercePrice?: CommercePrice | null;
  flatCodes?: Map<string, string>;
  // stock?: Map<string, number>;
  balancesOnGroupsOfWarehouses?: BalancesOnGroupsOfWarehouses;
  availabilityOnGroupsOfWarehouses?: AvailabilityOnGroupsOfWarehouses;
  markers?: Marker[];
  supplyTerm?: number;
  multiplicityOrder?: number;
  multiplicitySupplier?: number;
  selected?: boolean;
  importKey?: string;
  productStatusId?: number;
  similarProductList?: CartProduct[];
  analogCount?: number;
  width?: number;
  height?: number;
  length?: number;
  weight?: number;
  discountPrice?: number;
  discountCostOnlyTotal?: number;
}
